import { BrowserRouter as Router, Route, Switch, Link} from "react-router-dom";
import React, {useState, useEffect} from "react";

export default function NavMenu() {

    //#region стили
  const stateServices = () => {
    document.getElementById('services').classList.add('dropdown-toggle')
    document.getElementById('about').classList.remove('dropdown-toggle')
    document.getElementById('testimonial').classList.remove('dropdown-toggle')
    document.getElementById('discount').classList.remove('dropdown-toggle')
    document.getElementById('faq').classList.remove('dropdown-toggle')
    document.getElementById('blog').classList.remove('dropdown-toggle')
    document.getElementById('contacts').classList.remove('dropdown-toggle')
    document.getElementById('services').style.color = "#FFAB2D"
    document.getElementById('about').style.color = "#FFFFFF"
    document.getElementById('testimonial').style.color = "#FFFFFF"
    document.getElementById('discount').style.color = "#FFFFFF"
    document.getElementById('faq').style.color = "#FFFFFF"
    document.getElementById('blog').style.color = "#FFFFFF"
    document.getElementById('contacts').style.color = "#FFFFFF"
  }
  const stateAbout = () => {
    document.getElementById('services').classList.remove('dropdown-toggle')
    document.getElementById('about').classList.add('dropdown-toggle')
    document.getElementById('testimonial').classList.remove('dropdown-toggle')
    document.getElementById('discount').classList.remove('dropdown-toggle')
    document.getElementById('faq').classList.remove('dropdown-toggle')
    document.getElementById('blog').classList.remove('dropdown-toggle')
    document.getElementById('contacts').classList.remove('dropdown-toggle')
    document.getElementById('services').style.color = "#FFFFFF"
    document.getElementById('about').style.color = "#FFAB2D"
    document.getElementById('testimonial').style.color = "#FFFFFF"
    document.getElementById('discount').style.color = "#FFFFFF"
    document.getElementById('faq').style.color = "#FFFFFF"
    document.getElementById('blog').style.color = "#FFFFFF"
    document.getElementById('contacts').style.color = "#FFFFFF"
  }
  const stateTestimonial = () => {
   document.getElementById('services').classList.remove('dropdown-toggle')
    document.getElementById('about').classList.remove('dropdown-toggle')
    document.getElementById('testimonial').classList.add('dropdown-toggle')
    document.getElementById('discount').classList.remove('dropdown-toggle')
    document.getElementById('faq').classList.remove('dropdown-toggle')
    document.getElementById('blog').classList.remove('dropdown-toggle')
    document.getElementById('contacts').classList.remove('dropdown-toggle')
    document.getElementById('services').style.color = "#FFFFFF"
    document.getElementById('about').style.color = "#FFFFFF"
    document.getElementById('testimonial').style.color = "#FFAB2D"
    document.getElementById('discount').style.color = "#FFFFFF"
    document.getElementById('faq').style.color = "#FFFFFF"
    document.getElementById('blog').style.color = "#FFFFFF"
    document.getElementById('contacts').style.color = "#FFFFFF"
  }
  const stateDiscount = () => {
   document.getElementById('services').classList.remove('dropdown-toggle')
    document.getElementById('about').classList.remove('dropdown-toggle')
    document.getElementById('testimonial').classList.remove('dropdown-toggle')
    document.getElementById('discount').classList.add('dropdown-toggle')
    document.getElementById('faq').classList.remove('dropdown-toggle')
    document.getElementById('blog').classList.remove('dropdown-toggle')
    document.getElementById('contacts').classList.remove('dropdown-toggle')
    document.getElementById('services').style.color = "#FFFFFF"
    document.getElementById('about').style.color = "#FFFFFF"
    document.getElementById('testimonial').style.color = "#FFFFFF"
    document.getElementById('discount').style.color = "#FFAB2D"
    document.getElementById('faq').style.color = "#FFFFFF"
    document.getElementById('blog').style.color = "#FFFFFF"
    document.getElementById('contacts').style.color = "#FFFFFF"
  }
  const stateFaq = () => {
   document.getElementById('services').classList.remove('dropdown-toggle')
    document.getElementById('about').classList.remove('dropdown-toggle')
    document.getElementById('testimonial').classList.remove('dropdown-toggle')
    document.getElementById('discount').classList.remove('dropdown-toggle')
    document.getElementById('faq').classList.add('dropdown-toggle')
    document.getElementById('blog').classList.remove('dropdown-toggle')
    document.getElementById('contacts').classList.remove('dropdown-toggle')
    document.getElementById('services').style.color = "#FFFFFF"
    document.getElementById('about').style.color = "#FFFFFF"
    document.getElementById('testimonial').style.color = "#FFFFFF"
    document.getElementById('discount').style.color = "#FFFFFF"
    document.getElementById('faq').style.color = "#FFAB2D"
    document.getElementById('blog').style.color = "#FFFFFF"
    document.getElementById('contacts').style.color = "#FFFFFF"
  }
  const stateBlog = () => {
  document.getElementById('services').classList.remove('dropdown-toggle')
    document.getElementById('about').classList.remove('dropdown-toggle')
    document.getElementById('testimonial').classList.remove('dropdown-toggle')
    document.getElementById('discount').classList.remove('dropdown-toggle')
    document.getElementById('faq').classList.remove('dropdown-toggle')
    document.getElementById('blog').classList.add('dropdown-toggle')
    document.getElementById('contacts').classList.remove('dropdown-toggle')
     document.getElementById('services').style.color = "#FFFFFF"
    document.getElementById('about').style.color = "#FFFFFF"
    document.getElementById('testimonial').style.color = "#FFFFFF"
    document.getElementById('discount').style.color = "#FFFFFF"
    document.getElementById('faq').style.color = "#FFFFFF"
    document.getElementById('blog').style.color = "#FFAB2D"
    document.getElementById('contacts').style.color = "#FFFFFF"
  }
  const stateContacts = () => {
   document.getElementById('services').classList.remove('dropdown-toggle')
    document.getElementById('about').classList.remove('dropdown-toggle')
    document.getElementById('testimonial').classList.remove('dropdown-toggle')
    document.getElementById('discount').classList.remove('dropdown-toggle')
    document.getElementById('faq').classList.remove('dropdown-toggle')
    document.getElementById('blog').classList.remove('dropdown-toggle')
    document.getElementById('contacts').classList.add('dropdown-toggle')
    document.getElementById('services').style.color = "#FFFFFF"
    document.getElementById('about').style.color = "#FFFFFF"
    document.getElementById('testimonial').style.color = "#FFFFFF"
    document.getElementById('discount').style.color = "#FFFFFF"
    document.getElementById('faq').style.color = "#FFFFFF"
    document.getElementById('blog').style.color = "#FFFFFF"
    document.getElementById('contacts').style.color = "#FFAB2D"
}
  const stateCard = () => {
  document.getElementById('services').classList.add('dropdown-toggle')
    document.getElementById('about').classList.remove('dropdown-toggle')
    document.getElementById('testimonial').classList.remove('dropdown-toggle')
    document.getElementById('discount').classList.remove('dropdown-toggle')
    document.getElementById('faq').classList.remove('dropdown-toggle')
    document.getElementById('blog').classList.remove('dropdown-toggle')
    document.getElementById('contacts').classList.remove('dropdown-toggle')
    document.getElementById('services').style.color = "#FFAB2D"
    document.getElementById('about').style.color = "#FFFFFF"
    document.getElementById('testimonial').style.color = "#FFFFFF"
    document.getElementById('discount').style.color = "#FFFFFF"
    document.getElementById('faq').style.color = "#FFFFFF"
    document.getElementById('blog').style.color = "#FFFFFF"
    document.getElementById('contacts').style.color = "#FFFFFF"
}
//#endregion стили
const handleScroll = () => {
    const position = window.pageYOffset;
  if (position > 0) {
    document.getElementById("calc").style.display = "none"
    document.getElementById("adress").style.display = "none"
    document.getElementById("socseti").style.display = "none"
    document.getElementById("tel").style.display = "none"
    document.getElementById("logo0").style.display = "none"
    document.getElementById("tel2").style.display = "block"
  }
  else {
    document.getElementById("calc").style.display = "block"
    document.getElementById("adress").style.display = "block"
    document.getElementById("socseti").style.display = "block"
    document.getElementById("tel").style.display = "block"
    document.getElementById("logo0").style.display = "block"
    document.getElementById("tel2").style.display = "none"
  }
};

useEffect(() => {
  window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);

   return (
    <>
       <div id="navbar">
         <div className='row' id="top">
          <div><Link to="/"> <img id="logo0" src='../images/logo.png' /></Link></div>
          <div><a href="#bankcalc_" id='calc'  >Калькулятор стоимости</a></div>
          <div id='adress' >г. Волгоград, ул. 7-я Гвардейская д. 2<br />офис 218 (2 этаж)</div>
          <div id='socseti' ><a href="#"><img src='../images/vk.png' /></a><a href="#"><img src='../images/insta.png' /></a><a href="#"><img src='../images/youtube.png' /> </a></div>
          <div id='tel' ><a href="tel:+79999999999">+7 999 999 99 99</a></div>
        </div>
         <div id='menu'>
           <div className="row">
        <a href="/#linetop"  onClick={stateServices} id="services" className="dropdown-toggle menu">Услуги</a>
        <a href="/#aboutus_" onClick={stateAbout} id="about" className="menu">О нас</a>
        <a href="/#testimonials_" onClick={stateTestimonial} id="testimonial" className="menu">Отзывы</a>
        <a href="/#discounts_" onClick={stateDiscount} id="discount" className="menu">Акции</a>
        <a href="/#faqs_" onClick={stateFaq} id="faq" className="menu">Вопрос-ответ</a>
        <Link to="/blog/#blog" onClick={stateBlog} id="blog" className="menu">Блог</Link>
        <Link to="/contacts/#contacttitle" onClick={stateContacts} id="contacts" className="menu">Контакты</Link>
        <Link to="/card1/#card" onClick={stateCard} id="card_" className="menu"></Link>
        <a id='tel2' href="tel:+79999999999" ><img src="../images/phone.png" />+7 999 999 99 99</a>
           </div>
           </div> 
      </div>
      
    </>
  );
}